// extracted by css-extract-rspack-plugin
export default {"button":"oaSnx"};